import Text from './Text';
import { TextColor, TextWeight, TextSize, getSize, getColor, getWeight } from './utils';

export default function SmGrayMedium(props) {
  return (
    <Text
      {...props}
      size={TextSize.Sm}
      color={TextColor.GrayMedium}
    />
  );
}
